import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';

const routes: Routes = [
  { path: '', loadChildren: () => import('./core/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] }
  // { path: 'auth', loadChildren: () => import('./core/auth/auth.module').then(m => m.AuthModule) },
  // { path: '', loadChildren: () => import('./core/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
